<template>
  <div class="fixed-center z-9999 overlay-div">
    <div class="spinner-curve" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>

<style scoped>
.fixed-center {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.overlay-div{
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.spinner-curve {
  border: 6px solid #f0f0f0;
  border-top: 6px solid #7367f0;
  border-right: 6px solid #7367f0;
  border-radius: 50%;
  animation: spin-curve 0.8s linear infinite;
  width: 6rem;
  height: 6rem;
}

@keyframes spin-curve {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>